module.exports = __webpack_public_path__ + "img/gain-1.27d251e2.png";